import { createTheme, type Theme } from '@mui/material/styles';

import { vatItBrand } from '../colors';

export const vatItTheme = (theme: Theme) =>
  createTheme({
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        main: vatItBrand.vfile.main,
      },
      secondary: {
        main: vatItBrand.vsuite.main,
        text: vatItBrand.vsuite.text,
        hover: vatItBrand.vsuite.hover,
      },
      brand: {
        ...theme.palette.brand,
        ...vatItBrand,
      },
    },
  });
